import { createSlice } from '@reduxjs/toolkit'

const initialState = {
  errorObj: {
    errorCode: '',
    errorMessage: '',
  },
}

export const errorSlice = createSlice({
  name: 'error',
  initialState,
  reducers: {
    setError: (state, action) => {
      state.errorObj = action.payload
    },
  },
})

// Selectors
export const getErrors = (state) => state.error.errorObj

// Action creators are generated for each case reducer function
export const { setError } = errorSlice.actions

export default errorSlice.reducer
